import React from 'react'
import { Themed } from '@theme-ui/mdx'

export default function Header() {
  return (
    <header>
      <Themed.h1>Style Guide</Themed.h1>
    </header>
  )
}
